import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiLoaderComponent } from './ui-loader.component';
import {LoaderModule} from "@shared/loader/loader.module";


@NgModule({
  declarations: [
    UiLoaderComponent
  ],
  imports: [
      CommonModule,
      LoaderModule
  ],
  exports: [UiLoaderComponent]
})
export class UiLoaderModule { }
